export const types = {
    SESSION_UPDATE: 'SESSION_UPDATE',
    SESSION_CLEAR: 'SESSION_CLEAR',
    SESSION_CLEAR_ALL: 'SESSION_CLEAR_ALL',
};